export enum ServiceManagementPermissions {
  None = "None",
  IntegrationViewer = "IntegrationViewer",
  IntegrationManager = "IntegrationManager",
  IntegrationAdministrator = "IntegrationAdministrator",
  ServiceAdministrator = "ServiceAdministrator",
}
